import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";

import { useGetExpenseCategoryQuery, usePutExpenseCategoryMutation } from "../../../../../features/financialMangement/expense/expense-category/expense-categoryApiSlice";

import { notifyError, notifySuccess } from "../../../../../helpers/Notify";

const ExpenseCategory = () => {
  const [putExpenseCategory, { isLoading, isError, error }] = usePutExpenseCategoryMutation();
  const { data: expenseCategory = [], refetch } = useGetExpenseCategoryQuery();
  useEffect(() => {
    refetch();
  }, []);

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const user = localStorage.getItem("user");
  const [search, setSearch] = useState("");
  const recordsPage = 13;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;

  const filterExpenseCategories = () => {
    if (!search) return expenseCategory;

    return expenseCategory.filter((expense) => {
      const name = expense?.name?.toString().toLowerCase();
      const description = expense?.description?.toString().toLowerCase();

      return (
        name.includes(search.toLowerCase()) ||
        description.includes(search.toLowerCase())
      );
    });
  };

  const filteredExpenseCategories = filterExpenseCategories();
  const records = filteredExpenseCategories.slice(firstIndex, lastIndex);
  const npage = Math.ceil((filteredExpenseCategories.length || 0) / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);

  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    setCurrentPage(id);
  }
  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }

  const handleDelete = (expenseCategory) => {
    let updatedExpenseCategory = { ...expenseCategory };
    updatedExpenseCategory.isDeleted = true;
    updatedExpenseCategory.updatedBy = user?.userId;

    putExpenseCategory({
      id: updatedExpenseCategory?.expenseCategoryId,
      updatedExpenseCategory,
    })
      .unwrap()
      .then((response) => {
        notifySuccess("Expense category deleted successfully");
        refetch();
        navigate("expense-category");
      })
      .catch((error) => {
        console.error("Error updating service", error);
        notifyError(error);
      });
  };

  const handleEdit = (expense) => {
    navigate("expense-category/edit/" + expense?.expenseCategoryId);
  };

  const handleView = (expense) => {
    navigate("expense-category/view/" + expense?.expenseCategoryId);
  };

  const SweetAlert = (expense) =>
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        handleDelete(expense);

      } else {
        swal("Your data is safe!");
      }
    });

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects task-table">
                  <div className="tbl-caption d-flex justify-content-between align-items-center">
                    <h4 className="heading mb-0">Expense Category</h4>
                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        name="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search"
                        className="form-control me-2"
                      />

                      <Link
                        to={"expense-category/create"}
                        className="btn btn-primary light btn-sm me-2"
                        style={{ whiteSpace: 'nowrap', padding: '0.775rem 1.75rem' }}
                      >
                        <i className="fa-solid fa-plus me-2"></i>Add Category
                      </Link>
                    </div>
                  </div>
                  <div
                    id="task-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="empoloyeestbl2"
                      className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Description</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {records.map((expense, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{expense?.name}</td>
                            <td>{expense?.description}</td>
                            <td>
                              <span
                                onClick={() => handleView(expense)}
                                style={{
                                  marginRight: "8px",
                                  color: "blue",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fas fa-eye" title="View"></i>
                              </span>
                              <span
                                onClick={() => handleEdit(expense)}
                                style={{
                                  marginRight: "8px",
                                  color: "green",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fas fa-edit" title="Edit"></i>
                              </span>
                              <span
                                onClick={() => SweetAlert(expense)}
                                style={{ color: "red", cursor: "pointer" }}
                              >
                                <i className="fas fa-trash" title="Delete"></i>
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <div className="dataTables_info">
                        Showing {lastIndex - recordsPage + 1} to{" "}
                        {filteredExpenseCategories.length < lastIndex
                          ? filteredExpenseCategories.length
                          : lastIndex}{" "}
                        of {filteredExpenseCategories.length} entries
                      </div>
                      <div
                        className="dataTables_paginate paging_simple_numbers justify-content-center"
                        id="example2_paginate"
                      >
                        <Link
                          className="paginate_button previous disabled"
                          to="#"
                          onClick={prePage}
                        >
                          <i className="fa-solid fa-angle-left" />
                        </Link>
                        <span>
                          {number.map((n, i) => (
                            <Link
                              className={`paginate_button ${currentPage === n ? "current" : ""
                                } `}
                              key={i}
                              onClick={() => changeCPage(n)}
                            >
                              {n}
                            </Link>
                          ))}
                        </span>
                        <Link
                          className="paginate_button next"
                          to="#"
                          onClick={nextPage}
                        >
                          <i className="fa-solid fa-angle-right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpenseCategory;